import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "content"
};
var _hoisted_2 = {
  class: "block"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  class: "block block2"
};
var _hoisted_5 = {
  class: "public-box"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "public-box2"
};
var _hoisted_8 = {
  class: "cell red"
};
var _hoisted_9 = ["src"];
var _hoisted_10 = {
  class: "block"
};
var _hoisted_11 = {
  class: "public-box"
};
var _hoisted_12 = ["src"];
var _hoisted_13 = {
  class: "block block-wide"
};
var _hoisted_14 = {
  class: "public-box"
};
var _hoisted_15 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "rules-page",
    style: _normalizeStyle($options.pageBgStyle)
  }, [_createElementVNode("div", _hoisted_1, [_cache[15] || (_cache[15] = _createElementVNode("section", {
    class: "block"
  }, [_createElementVNode("h3", null, "活动主题"), _createElementVNode("p", null, "来起泡，发视频，赢大奖-首届泛文化视频共创大赛")], -1)), _cache[16] || (_cache[16] = _createElementVNode("section", {
    class: "block"
  }, [_createElementVNode("h3", null, "活动简介"), _createElementVNode("p", null, "十万现金大奖+百万流量曝光，邀你用镜头，解锁万千文化风华")], -1)), _createElementVNode("section", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("h3", null, "活动疑问 扫码咨询", -1)), _createElementVNode("p", null, [_createElementVNode("img", {
    src: $data.groupScan,
    alt: ""
  }, null, 8, _hoisted_3)])]), _cache[17] || (_cache[17] = _createStaticVNode("<section class=\"block\"><h3>活动时间</h3><p>作品投稿期：2026.5.13-2026.7.13</p><p>作品评分期：2026.7.14-2026.7.18</p><p>获奖公示期：2026.7.19-2026.7.23</p><p>结算周期：获奖公示期起5个工作日内完成所有获奖信息回收</p><p>作品合格审核期：活动投稿作品实时审核</p><p class=\"red\"> 获奖公布：获奖名单将在活动公示期通过【起泡App-消息-活动消息】告知或者通过起泡官方账号查看【获奖榜单】。 </p></section><section class=\"block\"><h3>参与对象</h3><p>短视频作者、历史爱好者、泛知识创作者</p></section>", 2)), _createElementVNode("section", _hoisted_4, [_cache[3] || (_cache[3] = _createElementVNode("h3", null, "创作方向参考包括但不限于以下内容", -1)), _cache[4] || (_cache[4] = _createElementVNode("ul", null, [_createElementVNode("li", null, "「随便怎么玩，灵感可以是👇👇 」"), _createElementVNode("li", null, "唠唠古人的日常八卦 / 职场生存 / 变美小技巧"), _createElementVNode("li", null, "挖一挖课本没讲的诗词歌赋冷知识"), _createElementVNode("li", null, "用镜头记录你眼里的山河与烟火"), _createElementVNode("li", null, "起泡新声赛道：不限题材、不限形式")], -1)), _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
    src: $data.jiantou,
    alt: ""
  }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
    src: $data.errorIcon,
    alt: ""
  }, null, 8, _hoisted_9), _cache[1] || (_cache[1] = _createTextVNode(" 友情提示：没有标准答案，你的脑洞就是 ", -1))]), _cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "cell red"
  }, " 最好的方向！ ", -1))])]), _createElementVNode("section", _hoisted_10, [_cache[5] || (_cache[5] = _createStaticVNode("<h3>创作要求</h3><h4>一、内容要求</h4><ul><li>内容为<span class=\"block-wide\">泛文化相关内容</span></li><li>禁止提交：谣言、低俗、违法违规、敏感政治</li></ul><h4>二、格式要求</h4><ul><li>视频时长<span class=\"\">&gt; 90s</span>，分辨率<span class=\"\">≥720P</span></li><li>画面要求：<span class=\"\">画面清晰稳定、无水印、无遮挡，音频清晰无杂音</span></li><li>版权要求：素材必须为<span class=\"\">原创</span>或<span class=\"\">已获得完整授权</span>，<span class=\"\">不得侵犯第三方版权、肖像权、名誉权</span>等合法权益；如因<span class=\"\">侵权</span>引发问题，责任由<span class=\"\">创作者自行承担</span>。</li></ul><h4>三、提交方式</h4><p>创作者通过<span class=\"block-wide\">app内置活动页提交</span>相关作品，填写信息包括：</p><p>1、素材原视频（无水印）</p><p>2、素材名称+简介</p><p>（参考：素材名称：xxx；历史时期：唐朝；核心内容：讲述唐太宗与魏征的君臣关系）</p>", 10)), _createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
    src: $data.jiantou,
    alt: ""
  }, null, 8, _hoisted_12)]), _cache[6] || (_cache[6] = _createElementVNode("p", {
    class: "red center"
  }, [_createTextVNode("提交后不可修改，请勿重复提交同一素材"), _createElementVNode("br"), _createTextVNode("（雷同素材只选用其中一条）")], -1))]), _cache[18] || (_cache[18] = _createStaticVNode("<section class=\"block\"><h3>评级规则</h3><div class=\"score-box\"><p class=\"hasNumber-p\">1、内容质量（40分）</p><p class=\"noNumber-p\">内容真实、观点有亮点、合规无风险</p><p class=\"hasNumber-p\">2、表现力（30分）</p><p class=\"noNumber-p\">叙事完整、制作清晰、节奏流畅</p><p class=\"hasNumber-p\">3、数据表现（30分）</p><p class=\"noNumber-p\">按平台播放/互动数据标准化打分</p></div><ul><li>最终排名以综合打分为主要依据</li></ul><p class=\"red public-p\">*注：抄袭、违规、跑题作品直接取消参评资格；最终排名以「综合总分」为唯一依据。作品时长为额外加分项，表现优秀可获得加分。</p></section>", 1)), _createElementVNode("section", _hoisted_13, [_cache[12] || (_cache[12] = _createElementVNode("h3", null, "活动奖励", -1)), _createElementVNode("div", {
    class: "prize-card prize-gold",
    style: _normalizeStyle($options.goldBgStyle)
  }, _toConsumableArray(_cache[7] || (_cache[7] = [_createElementVNode("div", {
    class: "prize-left"
  }, "一等奖（1名）", -1), _createElementVNode("div", {
    class: "prize-right"
  }, [_createElementVNode("p", null, "·3万元现金奖金"), _createElementVNode("p", null, "·平台长期签约合作资格"), _createElementVNode("p", null, "·获奖作品5万曝光扶持"), _createElementVNode("p", null, "·平台永久专属头像框")], -1)])), 4), _createElementVNode("div", {
    class: "prize-card prize-silver",
    style: _normalizeStyle($options.silverBgStyle)
  }, _toConsumableArray(_cache[8] || (_cache[8] = [_createElementVNode("div", {
    class: "prize-left"
  }, "二等奖（2名）", -1), _createElementVNode("div", {
    class: "prize-right"
  }, [_createElementVNode("p", null, "·1.5万元现金奖金"), _createElementVNode("p", null, "·起泡项目优先合作权"), _createElementVNode("p", null, "·获奖作品3万曝光扶持")], -1)])), 4), _createElementVNode("div", {
    class: "prize-card prize-bronze",
    style: _normalizeStyle($options.bronzeBgStyle)
  }, _toConsumableArray(_cache[9] || (_cache[9] = [_createElementVNode("div", {
    class: "prize-left"
  }, "三等奖（3名）", -1), _createElementVNode("div", {
    class: "prize-right"
  }, [_createElementVNode("p", null, "·5000元现金奖金"), _createElementVNode("p", null, "·获奖作品1万曝光扶持")], -1)])), 4), _createElementVNode("div", {
    class: "prize-card plain",
    style: _normalizeStyle($options.plainBgStyle)
  }, _toConsumableArray(_cache[10] || (_cache[10] = [_createElementVNode("div", {
    class: "prize-left"
  }, "优秀创作者专享", -1), _createElementVNode("div", {
    class: "prize-right"
  }, [_createElementVNode("p", null, "签约成为起泡首批创作者，额外获得500元现金奖励")], -1)])), 4), _createElementVNode("div", {
    class: "prize-card plain other",
    style: _normalizeStyle($options.plainBgStyle)
  }, _toConsumableArray(_cache[11] || (_cache[11] = [_createElementVNode("div", {
    class: "prize-left"
  }, "参与奖（不限）", -1), _createElementVNode("div", {
    class: "prize-right"
  }, [_createElementVNode("p", null, "基础合格作品统一获得平台流量扶持")], -1)])), 4), _createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
    src: $data.jiantou,
    alt: ""
  }, null, 8, _hoisted_15)]), _cache[13] || (_cache[13] = _createElementVNode("p", {
    class: "note"
  }, [_createElementVNode("span", {
    class: "block-wide"
  }, "规则说明："), _createTextVNode("用户投稿数量无上限，最终将依据作品综合打分进行排名，各项奖励不叠加发放，优秀创作者不与其他奖项叠加")], -1)), _cache[14] || (_cache[14] = _createElementVNode("p", {
    class: "red notice"
  }, "*注：以上现金奖励均为税前金额，曝光扶持为平台内流量资源。", -1))]), _cache[19] || (_cache[19] = _createElementVNode("section", {
    class: "block"
  }, [_createElementVNode("h3", null, "注意事项"), _createElementVNode("p", null, "1、严禁恶意刷稿、重复投稿相似作品，一经发现取消活动资格"), _createElementVNode("p", null, "2、起泡平台拥有活动最终解释权，如有调整将通过官方渠道提前通知。")], -1)), _cache[20] || (_cache[20] = _createElementVNode("section", {
    class: "block"
  }, [_createElementVNode("p", {
    class: "bold"
  }, "该活动与苹果公司无任何关系")], -1)), _cache[21] || (_cache[21] = _createElementVNode("div", {
    class: "placeholder-block"
  }, null, -1))])], 4);
}